import type { UserEventType } from './types'

export function assertUserEventType<T extends UserEventType['type']>(
  event: UserEventType,
  type: T
): asserts event is UserEventType & { type: T } {
  if (event.type !== type) {
    throw new Error(`Expected '${type}', got ${event.type}`)
  }
}
